import { Directive, ElementRef, HostListener, inject, input, model } from '@angular/core';

@Directive({
	selector: '[uiDropdownTrigger]',
	standalone: false,
})
export class DropdownTriggerDirective {
	public elementRef = inject(ElementRef);

	uiDropdownDisabled = input<boolean>(false);
	toggleRequest = model<(() => void) | null>(null);
	isOpenWithKeyboard = model<boolean>(false);

	/** When the opening should only be triggered programmatically **/
	ignoreTrigger = input<boolean>(false);
	triggerWithEnterKey = input<boolean>(false);

	@HostListener('click')
	onClick() {
		if (this.shouldTriggerDropdown()) {
			this.isOpenWithKeyboard.set(false);
			this.toggleDropdown();
		}
	}

	@HostListener('keydown.enter')
	onKeyDownEnter() {
		if (this.shouldTriggerDropdown() && this.triggerWithEnterKey()) {
			this.isOpenWithKeyboard.set(true);
			this.toggleDropdown();
		}
	}

	private shouldTriggerDropdown(): boolean {
		return !this.uiDropdownDisabled() && !this.ignoreTrigger();
	}

	private toggleDropdown(): void {
		this.toggleRequest()?.();
	}
}
